import { render, staticRenderFns } from "./IconSoundcloud.vue?vue&type=template&id=2f0eb1d2&"
import script from "./IconSoundcloud.vue?vue&type=script&lang=js&"
export * from "./IconSoundcloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports